import { FCWW } from '../../../types.ts';
// @ts-ignore
import classNames from 'classnames';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { i18n } from '@/translation/TranslationProvider.tsx';

interface SlideWrapperProps {
  sidePanelVisible: boolean;
}

export const SlideWrapper: FCWW<SlideWrapperProps> = ({ children, sidePanelVisible }) => {
  const { eventConfig } = useEventConfig();
  const { currentSlide } = useNavigation();
  const locale = i18n.locale;

  const appClassNames = {
    [`country-${eventConfig!.meta.country}`]: true,
    [`locale-${locale}`]: true,
    [`event-${eventConfig!.meta.eventCode}`]: true,
    [`slide-${currentSlide?.id}`]: true,

    'has-nav': true,
    'has-cancel': currentSlide?.cancel !== false,
    'has-info': !!currentSlide?.info,
    'has-header': currentSlide?.header !== false,
    'sidepanel-visible': sidePanelVisible,
    'device-ios': navigator.userAgent.match(/(iPad|iPhone|iPod)/i) || false,
    'device-android': navigator.userAgent.match(/android/i) || false,
    'is-safari': navigator.userAgent.match('Version') || false,
  };

  return <div className={'App h-100 ' + classNames(appClassNames)}>{children}</div>;
};
